<template>
<div>
		<v-card-text class="pa-0" style="height: 500px; overflow-y: auto;">
			<div v-if="account">
			<div v-for="group in groups">
				<v-card>
					<v-card-title><h4>{{group.name}}</h4></v-card-title>
					<v-divider></v-divider>
					<v-list dense>
						<v-list-tile>
							<v-list-tile-content style="width: 140px;">Channels:</v-list-tile-content>
							<v-list-tile-content style="flex-direction: row; width: 100%; justify-content: left;">
								<v-chip small v-for="channel in get_channels(group.channels)">{{channel.type}}: {{channel.title}}</v-chip>
							</v-list-tile-content>
						</v-list-tile>

						<v-list-tile>
							<v-list-tile-content style="width: 140px; ">Content lists:</v-list-tile-content>
							<v-list-tile-content style="flex-direction: row; width: 100%; justify-content: left;">
								<v-chip small v-for="cms_list in get_cms_lists(group.cms_lists)">{{cms_list.name}}</v-chip>
							</v-list-tile-content>
						</v-list-tile>


						<v-list-tile>
							<v-list-tile-content style="width: 140px; ">Content list types:</v-list-tile-content>
							<v-list-tile-content style="flex-direction: row; width: 100%; justify-content: left;">
								<v-chip small v-for="cms_list_type in get_cms_list_types(group.cms_list_types)">{{cms_list_type.name}}</v-chip>
							</v-list-tile-content>
						</v-list-tile>
						

						<v-list-tile>
							<v-list-tile-content style="width: 140px; ">Events: </v-list-tile-content>
							<v-list-tile-content style="flex-direction: row; width: 100%; justify-content: left; overflow: scroll;">
								<v-chip small v-for="event in get_events(group.events)">{{event}}</v-chip>
							</v-list-tile-content>
						</v-list-tile>


					</v-list>
				</v-card>

			</div>
		</div>
  	</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      &nbsp;
    </v-card-actions>
  </div>
</template>

<script>
export default {
  props: ['id'],
  components: {
  },
  data () {
    var ch = this.$cloudserver.channel("accounts:"+(this.id||"create"));
    return {
      ws_channel: ch,
      account: this.convertAccount(ch.data)
    }
  },
  watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				if(typeof(newVal) != "undefined") {
					this.account = this.convertAccount(newVal, oldVal);
				}
			},
			deep: true
		},
		'$route' (to, from) {
			if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
				this.ws_channel = this.$cloudserver.channel("accounts:"+(this.id||"create"));
				this.ws_channel.join();
			}
		}
	},
  created() {
    this.ws_channel.join();
  },
  computed: {
    is_edit () {
      return typeof(this.account) != "undefined" && this.account.id != null;
    },
    groups () {
    	var self = this;
    	return _.map(this.account.groups, (group_uuid) => {
    		return self.$store.state.groups_uuid[group_uuid] || {};
    	});
    }
  },
  methods: {
  	get_channels (channels) {
  		var self = this;
  		return _.map(channels, (channel_uuid) => {
  			return self.$store.state.channels_uuid[channel_uuid];
  		})
  	},
  	get_cms_lists (cms_lists) {
  		var self = this;
  		return _.map(cms_lists, (id) => {
  			return self.$store.state.cms_lists[id];
  		})
  	},
  	get_cms_list_types (cms_list_types) {
  		var self = this;
  		return _.map(cms_list_types, (id) => {
  			return self.$store.state.cms_list_types[id];
  		})
  	},
  	get_events (events) {
  		var self = this;
  		return _.map(events, (event_uuid) => {
  			return event_uuid;
  		})
  	},
    convertAccount (newVal, oldVal) {
      var account = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }

      if(typeof(account) == "undefined" || _.isEmpty(account)) return undefined;

      return account;
    }
  }
}
</script>
